import { authFetch } from '@/lib/auth/authFetch';
import { API_BASE_URL } from '@/utils/api';

const API_URL = `${API_BASE_URL}/brand-config`;

async function getBrandDetails(brandID, accessToken) {
  try {
    const headers = {};
    // Only include auth header if we have a valid token
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }
    const response = await authFetch(`${API_URL}/details/${brandID}`, {
      headers,
    });
    const data = await response.json();
    return {
      statusCode: 200,
      body: data,
    };
  } catch (_error) {
    return {
      statusCode: 500,
      body: JSON.stringify({ error: 'Failed to get details' }),
    };
  }
}

export { getBrandDetails };
